import { Container as ContainerBase } from 'components/misc/Layouts.js';
import tw from 'twin.macro';
import logo from '../../images/logo.png';

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-8 lg:py-12 mt-8`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-40`;

const LinksContainer = tw.div`mt-4 font-medium flex flex-wrap justify-center items-center  sm:flex-row`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

// const SocialLinksContainer = tw.div`mt-4`;
// const SocialLink = styled.a`
//     ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
//     svg {
//         ${tw`w-5 h-5`}
//     }
// `;

const CopyrightText = tw.p`text-center mt-4 font-medium tracking-wide text-sm text-gray-600`;
export default () => {
    return (
        <Container>
            <Content>
                <Row>
                    <LogoContainer>
                        <LogoImg src={logo} />
                    </LogoContainer>
                    <LinksContainer>
                        <Link href="#o-nama">O nama</Link>
                        {/* <Link href="#utisci">Utisci</Link> */}
                        <Link href="#pitanja">Česta pitanja</Link>
                        <Link href="#kontakt">Kontakt</Link>
                    </LinksContainer>
                    {/* <SocialLinksContainer>
                        <SocialLink href="https://facebook.com">
                            <FacebookIcon />
                        </SocialLink>
                        <SocialLink href="https://twitter.com">
                            <TwitterIcon />
                        </SocialLink>
                        <SocialLink href="https://youtube.com">
                            <YoutubeIcon />
                        </SocialLink>
                    </SocialLinksContainer> */}
                    <CopyrightText>&copy; 2025. Poslovna analitika. Sva prava zadržana.</CopyrightText>
                </Row>
            </Content>
        </Container>
    );
};
